import { Chip } from "@mui/material";

export const CustomIconsPlusText = ({
  icon: Icon,
  iconStyles,
  text,
  severity,
  blink,
  variant,
  chipStyles
}) => {
  return (
    <Chip
      className="generalCssForStates"
      sx={{ borderRadius: "4px", mx: 0.5, ...(chipStyles || {}) }}
      color={severity || undefined}
      icon={Icon ? <Icon className={blink || ""} style={iconStyles} /> : undefined}
      variant={variant || "outlined"}
      label={text}
      size="small"
    />
  );
};
